export const hasDirtyFields = (dirtyFields: unknown): boolean => {
  if (dirtyFields === true) {
    return true;
  }
  if (dirtyFields && typeof dirtyFields === 'object') {
    return Object.values(dirtyFields).some(hasDirtyFields);
  }
  return false;
};
